

















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Plus extends Vue {
  @Prop({ default: '10' }) readonly width?: string;
  @Prop({ default: '6' }) readonly height?: string;
  @Prop({ default: '#92A2B0' }) readonly fill?: string;
}
